import dayjs from 'dayjs';

export default {
  install: (Vue, {
    store,
  }) => {
    Vue.prototype.$dayjs = dayjs;
    Vue.dayjs = dayjs;
    store.$dayjs = dayjs;
  },
};
